import $ from 'jquery';
import "flexslider";


$(document).ready(function() {
    if( $('.mainslider-intranet').length ) {

        $(".mainslider-intranet").flexslider({
            animation: "slide", 
            slideshow: true,
            slideshowSpeed: 6000,
            controlNav: true,
            animationLoop: true,
            touch: true,
            pauseOnHover: false,
            pauseOnAction: true,
            controlsContainer: ".flexcontrols"
        });

    }
    
    if( $('.flexslider-bulletin').length ) {

        $(".flexslider-bulletin").flexslider({
            animation: "fade", 
            slideshow: true,
            slideshowSpeed: 4000,
            controlNav: true,
            animationLoop: true,
            touch: false,
            pauseOnHover: false,
            pauseOnAction: false,
            controlNav: false,
            directionNav: false
        });

    }

}); 



